import script from "./CaskUserSelfToolTip.vue?vue&type=script&setup=true&lang=js"
export * from "./CaskUserSelfToolTip.vue?vue&type=script&setup=true&lang=js"

import "./CaskUserSelfToolTip.vue?vue&type=style&index=0&id=03bca354&lang=scss"

const __exports__ = script;

export default __exports__
import QMenu from 'quasar/src/components/menu/QMenu.js';
import QAvatar from 'quasar/src/components/avatar/QAvatar.js';
import QImg from 'quasar/src/components/img/QImg.js';
import QBadge from 'quasar/src/components/badge/QBadge.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QMenu,QAvatar,QImg,QBadge,QIcon,QBtn});
